<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      :show-export="false"
      quick-search-props="name"
      :default-sorter="[{ direction: 'DESC', property: 'updateTime' }]"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="showDialog()" type="primary">添加</el-button>
          <fe-delete-button url="${portal}/sys/category/v1/remove" :htTable="$refs.ecoTable" class="marginLeft16">删除</fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="id" label="主键" hidden />
        <eco-table-column prop="name" label="分类名称" :sortable="true" />
        <eco-table-column prop="groupKey" label="分类组业务主键" :sortable="true" :show-overflow-tooltip="true" />
        <!-- <eco-table-column prop="type" label="类型">
          <template v-slot="{row}">
            <el-tag v-if="row.type==1">树形结构</el-tag>
            <el-tag type="danger" v-else>平铺结构</el-tag>
          </template>
        </eco-table-column> -->
        <eco-table-column width="150" label="操作">
          <template v-slot="{ row }">
            <el-link :underline="false" type="primary" @click="handleCommand({ row: row, command: 'edit' })">编辑</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>

    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      :title="(model.id ? '编辑' : '添加') + '分类标识'"
      :visible="dialogVisible"
      :before-close="handleClose"
      append-to-body
    >
      <el-form v-model="model" data-vv-scope="editModelForm" style="padding: 20px">
        <eco-form-item label="分类名称" label-width="120px">
          <eco-input v-model="model.name" autocomplete="off" :validate="{ required: true }" placeholder="请输入分类名称"></eco-input>
        </eco-form-item>
        <eco-form-item label="分类业务主键" label-width="120px">
          <eco-input
            v-model="model.groupKey"
            v-pinyin="model.name"
            autocomplete="off"
            :disabled="model.id ? true : false"
            :validate="{ required: true, alpha_dash: true }"
            placeholder="请输入分类业务主键"
          ></eco-input>
        </eco-form-item>
        <!-- <eco-form-item label="类型">
          <eco-radio
            v-model="model.type"
            :options="[{ key: 0, value: '平铺结构'}, { key: 1, value: '树形结构'}]"
          />
        </eco-form-item> -->
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="handleClose()">{{ $t('eip.common.cancel') }}</el-button>
        <fe-submit-button url="/sys/category/v1/save" context="portal" :model="model" scope-name="editModelForm" @after-save-data="afterSaveData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
import portalApi from '@/api/portal.js'

export default {
  components: {},
  computed: {},
  data() {
    return {
      dialogVisible: false,
      model: {
        name: '',
        groupKey: '',
        type: 1
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    this.$validator = this.$root.$validator
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    showDialog(row) {
      this.dialogVisible = true
      if (row) {
        this.model = row
        this.model.updateTime = ''
        this.model.createTime = ''
        setTimeout(() => this.$validator.validateAll())
      } else {
        this.model = { id: '', name: '', type: 0, groupKey: '' }
      }
    },
    loadData(param, cb) {
      portalApi
        .getSysCatByPage(param)
        .then((response) => {
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    handleCommand(params) {
      switch (params.command) {
        case 'edit':
          this.showDialog(params.row)
          break
        default:
          break
      }
    },
    afterSaveData() {
      this.dialogVisible = false
      this.$refs.ecoTable.load()
    }
  }
}
</script>
<style scoped>
div[aria-invalid='true'] >>> .el-input__inner,
div[aria-invalid='true'] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
